angular
  .module('contabilidad.polizas')
  .service('deudoresDiversosEgresosService', Service)

Service.$inject = ['$api', '$filter', '$schema']

function Service ($api, $filter, $schema) {
  var deudoresDiversosEgresosService = this

  deudoresDiversosEgresosService.obtenerInformacionDeudoresDiversosEgresos = obtenerInformacionDeudoresDiversosEgresos
  deudoresDiversosEgresosService.condificardeudoresDiversosEgresos = condificardeudoresDiversosEgresos

  function obtenerInformacionDeudoresDiversosEgresos (fecha_inicio, fecha_fin, ids_empresas) {
    return $api.get('/kendu/contabilidad/polizas/polizasDeudoresDiversosEgresos', {
      fecha_inicio: fecha_inicio.toYMD(),
      fecha_fin: fecha_fin.toYMD(),
      ids_empresas: ids_empresas,
    }, {schema: schema}).then(function (data) {
      data.data.map(function (item) {
        item.ID_EmpleadoZ = ('000000' + item.ID_Empleado).slice(-6)
        item.ID_EmpresaZ = ('0000' + item.ID_Empresa).slice(-4)
      })
      return data
    })
  }

  var verificarCadena = $filter('rPad')

  function condificardeudoresDiversosEgresos (data, inicio_poliza) {
    var cadenaPrincipal = ''
    var cadA = 'P  AAAAMMDD    2      JJJJ 1 0          ' +
      'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n'
    var cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' + '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n'

    var fechaA,
      fechaB
    try {
      data.forEach(function (item) {
        fechaA = $filter('date')(item.Fecha_Movimiento, 'yyyyMMdd')
        fechaB = item.Banco_Referencia.indexOf('a') > 0 ? $filter('date')(item.Fecha_Movimiento, 'dd/MM/yyyy') : item.Banco_Referencia
        cadenaPrincipal += cadA
          .replace('AAAAMMDD', fechaA)
          .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
          .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena(item.Descripcion, 60))

        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable.replace(/-/g, ''), 16))
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(fechaB, 15))
          .replace('*', 1)
          .replace('YYYYYYYYY', verificarCadena(item.TotalBanco.toFixed(2), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(item.Descripcion, 43))

        if (item.Tipo_Moneda === '2') {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(fechaB, 15))
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena(item.TotalComple.toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(item.Descripcion, 43))
        }

        item.cuentas.forEach(function (ele) {

          cadenaPrincipal += cadB
          // .replace("CCCCCCCCCCCCCCCC", verificarCadena(("1070060" + ele.ID_EmpresaZ + ele.ID_EmpleadoZ), 16))
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(('107006' + ele.ID_EmpresaZ + '0000000'), 16))
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(fechaB, 15))
            .replace('*', 0)
            .replace('YYYYYYYYY', verificarCadena((ele.Tipo_Moneda === '1' ? ele.Importe : ele.ImpDiv).toFixed(2), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((ele.Descripcion + ' ' + ele.Notas), 43))

        })

        inicio_poliza++
      })

      return cadenaPrincipal
    } catch (err) { // try
      return 'Error'
    }
  }

  var schema = {
    data: {
      Captura_Fecha: 'data',
      Importe: 'number',
      ImpDiv: 'number',
      Comple: 'number',
    },
  }

}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/deudoresDiversosEgresosService.js